<template>
    <div class="common_container">
        <el-form :rules="rules" ref="messageForm" :model="messageForm" label-width="100px">
            <el-form-item label="文档目录" prop="company">
                <el-cascader ref="getDefaultValue" v-model="messageForm.company" :props="propsData" class="form-input"></el-cascader>
            </el-form-item>
            <el-form-item label="文档" prop="uploadMesList">
                <!-- <input type="file" @change="uploadPic"/>
                <div v-show="isShowErrorMes">
                    <span class="errorColor">{{showErrorMes}}</span>
                </div> -->
                <a href="javascript:void(0);" class="input">
                上传文件
                    <input type="file" id="file" name="document[file]" @change="uploadPic">
                </a>
                <span class="errorColor" v-show="isShowErrorMes">{{showErrorMes}}</span>
                <div v-if="messageForm.uploadMesList.length>0">
                    <div v-for="(item, index) in messageForm.uploadMesList" :key="index">{{item.file_name}}</div>
                </div>
            </el-form-item>
            <el-form-item label="文档状态" prop="value">
                <el-select v-model="messageForm.value" placeholder="请选择" class="form-input">
                    <el-option
                        v-for="item in documentStatus"
                        :key="item.id"
                        :label="item.cname"
                        :value="item.id">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="描述" prop="desc">
                <el-input type="textarea" v-model="messageForm.desc" class="form-input"></el-input>
            </el-form-item>
            <!-- <el-form-item label="版本:">
                <span>1</span>
            </el-form-item> -->
            <el-form-item>
                <el-button type="primary" @click="submit">确认</el-button>
                <el-button @click="onCancel">取消</el-button>
            </el-form-item>
        </el-form>
    </div>
</template>

<script>
    import services from "./event.service";
    import commonService from "../../services/common.service";
    import { getRules } from "./document.rules";
    const rules = getRules();
    export default {
        props:{
            type:{//类型  默认 add =>新增    edit => 修改
                type:String,
                default:"add"
            },
            message:{//修改的信息
                type:Object,
            },
            callback: {//回掉处理
                type: Function
            }
        },
        data() {
            return {
                formName:"messageForm",
                rules:rules,
                // company: [],//选择上级
                propsData: {
                    lazy: true,
                    checkStrictly: true,
                    lazyLoad (node, resolve) {
                        const { level } = node;
                        if(level<1){
                            services.getNoPageDirectoryList({"parentId":"0"}).then(res => {
                                let nodes = [];
                                res.forEach(item=>{
                                    nodes.push({value: item.id,label: item.title,leaf:!item.hasChildren})
                                })
                                // 通过调用resolve将子节点数据返回，通知组件数据加载完成
                                resolve(nodes);
                            }).catch(err => {
                                this.$message.error(err.message);
                            }).finally(() => {
                                this.loading = false;
                            })
                        }else{
                            services.getNoPageDirectoryList({"parentId":node.data.value}).then(res => {
                                let nodes = [];
                                res.forEach(item=>{
                                    nodes.push({value: item.id,label: item.title,leaf:!item.hasChildren})
                                })
                                // 通过调用resolve将子节点数据返回，通知组件数据加载完成
                                resolve(nodes);
                            }).catch(err => {
                                this.$message.error(err.message);
                            }).finally(() => {
                                this.loading = false;
                            })
                        }
                    }
                },
                messageForm: {//表单信息
                    level: '',
                    name: '',
                    sort: '',
                    desc: '',
                    value:'',
                    company:[],
                    uploadMesList:[]
                },
                fileList:[],
                // options: [
                //     {
                //         value: '0',
                //         label: '新建'
                //     }, {
                //         value: '1',
                //         label: '待审核'
                //     }, {
                //         value: '-2',
                //         label: '审核不通过'
                //     }, {
                //         value: '2',
                //         label: '发布'
                //     }, {
                //         value: '-3',
                //         label: '废止'
                //     }
                // ],
                // value: '0',
                showErrorMes:'请选择文件',//文件上传不对时展示的信息
                isShowErrorMes:false,//是否展示错误信息
                uploadMes:{},//上传文件信息
                // getDefaultValue:'',
                // uploadMesList:[],
            }
        },
        mounted(){
            if(this.type == 'edit'){//返显需要修改的信息
                services.getDocDetail({id:this.message.id}).then(res=>{
                    // console.log(res);
                    this.$refs.getDefaultValue._data.inputValue = res.dirTitle;
                    // this.getDefaultValue = res.dirTitle;
                    this.messageForm.uploadMesList.push({
                        "file_name":res.title,
                        "download_url":res.docUrl,
                        "uploaded_size":res.size,
                        "file_id":res.fileId,
                    })
                    this.uploadMes = this.messageForm.uploadMesList[0];
                })
            }
        },
        created() {
            // console.log(this.dictionary,'字典');
            // console.log(this.documentStatus);
            if(this.type == 'edit'){//返显需要修改的信息
                this.$modal.title = "修改";
                // console.log(this.message,'message');
                // this.messageForm.name = this.message.title;
                // this.company[0] = this.message.parentId;
                // this.value = this.message.status;
                this.messageForm.desc = this.message.description;
                this.messageForm.value = this.message.status.toString();
                this.messageForm.company[0] = this.message.dirId;
            }
        },
        computed:{
            dictionary(){
                return this.$store.state.dictionary;
            },
            documentStatus(){
                return this.dictionary.document_status
            }
        },
        methods:{
            submit(){//提交
                let params = {
                    "title":this.uploadMes.file_name,
                    "dirId":this.messageForm.company[this.messageForm.company.length-1],
                    "docUrl":this.uploadMes.download_url,
                    "size":this.uploadMes.uploaded_size,
                    "description":this.messageForm.desc,
                    "fileId":this.uploadMes.file_id,
                    "status":this.messageForm.value,
                };
                let formName = this.formName;
                this.$refs[formName].validate((valid) => {
                    this.isShowErrorMes = !valid;
                    if(valid){
                        if(this.type == 'edit'){
                            params.id = this.message.id;
                            services.updateDoc(params).then(res => {
                                this.$message.success("事件修改成功");
                                this.close(true);
                            }).catch(err => {
                                this.$message.error(err.message);
                            })
                        }else{
                            services.addDoc(params).then(res => {
                                this.$message.success("事件添加成功");
                                this.close(true);
                            }).catch(err => {
                                this.$message.error(err.message);
                            })
                        }
                    };
                    return valid;
                })
            },
            onCancel(){//取消
                this.close();
            },
            close(refresh) {//关闭该弹框   refresh => true 刷新列表
                this.$modal.close();
                refresh && refresh === true ? this.callback() : '';
            },
            uploadPic(e){
                let file = e.target.files || e.dataTransfer.files;
                // this.isShowErrorMes = false;
                commonService.uploading({file_name:file[0]}).then(res=>{
                    this.messageForm.uploadMesList = [];
                    this.uploadMes = res;
                    this.messageForm.uploadMesList.push(res);
                    this.$message.success("文件上传成功");
                })
            }
        }
    }
</script>

<style scoped>
    .errorColor{
        color:red;
    }
    .common_container a.input {
        width:70px;
        height:30px;
        color:#FFF !important;
        cursor:pointer;
        line-height:30px;
        text-align:center;
        display:inline-block;/*具有行内元素的视觉，块级元素的属性 宽高*/
        overflow:hidden;/*去掉的话，输入框也可以点击*/
        position:relative;/*相对定位，为 #file 的绝对定位准备*/
        top:10px;
    }
    a.input:hover {
        background:#31b0d5;
        color: #ffffff;
    }
    a{
        text-decoration:none;
        color:#FFF;
    }
    #file {
        opacity:0;/*设置此控件透明度为零，即完全透明*/
        filter:alpha(opacity=0);/*设置此控件透明度为零，即完全透明针对IE*/
        font-size:100px;
        position:absolute;/*绝对定位，相对于 .input */
        top:0;
        right:0;
    }
</style>
